import api from 'services/api';

export const verifyCpf = async (cpf) => {
  // Reuse existing GET /pacientes with query param cpf
  const response = await api.get('/pacientes', { params: { cpf } });
  return response.data; // Expected to be an array (empty if not found)
};
